/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Pflegenbeitrag1Inputs */



/**

* @param {_Field_Pflegenbeitrag1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_pflegenbeitrag1 = /** @type {((inputs?: _Field_Pflegenbeitrag1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Pflegenbeitrag1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Priv. Pflegeversicherungsbeitrag")
});
export { _field_pflegenbeitrag1 as "_field_pflegenBeitrag" }